/** Current raw tongue-and-groove roof board specification, shared by takeoff and geometry. */
export const ROOF_DECKING_THICKNESS_MM = 23;

/** A sheared roof mesh uses vertical thickness; the board specification is normal to the slope. */
export function roofDeckingVerticalThicknessMm(pitchRad: number): number {
  if (!Number.isFinite(pitchRad) || Math.abs(pitchRad) >= Math.PI / 2) {
    throw new RangeError('Roof pitch must be finite and less than 90 degrees in magnitude');
  }
  return ROOF_DECKING_THICKNESS_MM / Math.cos(pitchRad);
}
